import { render, staticRenderFns } from "./SelfPublishing.vue?vue&type=template&id=4cac50cb&scoped=true&"
import script from "./SelfPublishing.vue?vue&type=script&lang=js&"
export * from "./SelfPublishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cac50cb",
  null
  
)

export default component.exports